'use client';

import { reatomContext, useCreateCtx } from '@reatom/npm-react';
import { FcmTokenProvider } from '@trwl/provider/fcmTokenProvider';
import { LoadDataProvider } from '@trwl/provider/loadDataProvider';
import { fcmTokenAtom } from '@trwl/store/atoms/fcmToken';
import { PropsWithChildren, useEffect } from 'react';

export const Providers = ({ children }: PropsWithChildren) => {
  const ctx = useCreateCtx();

  useEffect(() => {
    const handlePushToken = (event: CustomEvent) => {
      const pushToken: string = event.detail;
      fcmTokenAtom(ctx, pushToken || null);
    };

    window.addEventListener('push-token', handlePushToken as EventListener);

    return () => {
      window.removeEventListener(
        'push-token',
        handlePushToken as EventListener,
      );
    };
  }, [ctx]);

  return (
    <reatomContext.Provider value={ctx}>
      <FcmTokenProvider>
        <LoadDataProvider>{children}</LoadDataProvider>
      </FcmTokenProvider>
    </reatomContext.Provider>
  );
};
